import { render, staticRenderFns } from "./BtnFontSize.vue?vue&type=template&id=f2f76f2e&scoped=true&"
import script from "./BtnFontSize.vue?vue&type=script&lang=js&"
export * from "./BtnFontSize.vue?vue&type=script&lang=js&"
import style0 from "./BtnFontSize.vue?vue&type=style&index=0&id=f2f76f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f76f2e",
  null
  
)

export default component.exports